import React, { useState } from "react";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { fetchAllPostPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast, successToast } from "../../../../common/utils/methods/toasterFunctions/function";
import { endpoint } from "../../../../common/constant";
import ALoader from 'views/pages/manage/common/a-loader';
const btnsStyle = {
  display: "flex",
  flexDirection: "row-reverse",
  marginTop: "10px",
  columnGap: "10px",
};
const CoursePackageMappingPop = ({ dropdown, resetCheckBoxMap, selectedCourseIds, closeModal }) => {
    const [selectedPackage, setSelectedPackage] = useState([])
    const [isLoading ,setLoading] = useState(false);
    const formResetHandler = (flag)=>{
         setSelectedPackage([]);
         closeModal()
         flag &&  resetCheckBoxMap({})
    }
    const updatePackageAPI = async()=>{
        const courseIds = []
        setLoading(true)
        try {
            for (const [id, value] of Object.entries(selectedCourseIds)){
                if(value) courseIds.push(id)
           }
           const url = endpoint.onlinePackage.updatePackageId ;
           const packageIds = selectedPackage.map((item=>item.value))
           if(!packageIds.length) {
            setLoading(false)
            return failureToast("Please select at least one Online Package Id before applying.")}
           const request = {
               courseFeeApprovalDetailsIdList:courseIds,
               onlinePackage:packageIds.join("_")
           }
           await fetchAllPostPromisedData(url, request)
           successToast(`Online Package Ids updated for ${courseIds.length} rows`)
           setTimeout(()=>formResetHandler("CLEAR_CHECKBOX_MAP"), 3000)
        } catch (error) {
             console.log("something went wrong", error)
        }finally{
            setLoading(false)

        }
        
        
    }
    

  return (
    <div>
        {isLoading && <ALoader/>}
      <AAutoComplete
        label="Online Package ID"
        currentValue={selectedPackage}
        items={dropdown}
        handleChange={(value) => setSelectedPackage(value)}
        height={"40px"}
        isShowCount ={true}
      />
      <div style={btnsStyle}>
        <AButton
          variant="primary_filled"
          onClick={updatePackageAPI}
          size="xs"
        >
          Apply Update
        </AButton>{" "}
        <AButton
          variant="danger_filled"
          onClick={()=>formResetHandler()}
          size="xs"
          className="no-ml-btn"
        >
          Cancel
        </AButton>
      </div>
    </div>
  );
};

export default CoursePackageMappingPop;
